import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PrototypeApp from './PrototypeApp';
import AdminUsuarios from './AdminUsuarios';
import AdminMembrosPortal from './AdminMembrosPortal';
import AdminCriancasPortal from './AdminCriancasPortal';
import AdminVisitantes from './AdminVisitantes';
import AdminAcolhimento from './AdminAcolhimento';
import AdminRepertorio from './AdminRepertorio';
import RepertorioMusico from './RepertorioMusico';
import AdminEscalas from './AdminEscalas';
import AdminAniversariantes from './AdminAniversariantes';
import AdminAgente from './AdminAgente';
import AdminAgentRelatorio from './AdminAgentRelatorio';
import AdminAnalytics from './AdminAnalytics';
import AdminHome from './AdminHome';
import InstitutionalLayout from './institutional/InstitutionalLayout';
import Home from './institutional/pages/Home';
import Sobre from './institutional/pages/Sobre';
import Ministerios from './institutional/pages/Ministerios';
import Pregacoes from './institutional/pages/Pregacoes';
import Eventos from './institutional/pages/Eventos';
import Contato from './institutional/pages/Contato';
import Faq from './institutional/pages/Faq';
import Devocionais from './institutional/pages/Devocionais';
import CadastroMembro from './institutional/pages/CadastroMembro';
import CadastroCrianca from './institutional/pages/CadastroCrianca';
import CadastroVisitante from './institutional/pages/CadastroVisitante';
import ViewAsRoleBanner from './components/ViewAsRoleBanner';
import AgenteWidgetVisibility from './components/AgenteWidgetVisibility';

// O domínio "familia.batistamosaico.com.br" já é usado hoje pelos membros pra
// acessar o Família Mosaico direto na raiz (/) — não pode virar a home
// institucional só porque este mesmo build agora também sabe servi-la.
// Então a decisão de qual app mostrar na raiz depende do host de acesso:
//   - familia.batistamosaico.com.br (e localhost, pra manter o fluxo de dev
//     do módulo autenticado sem surpresa) -> comportamento 100% inalterado,
//     Família Mosaico direto na raiz, como sempre foi.
//   - qualquer outro host (ex.: www.batistamosaico.com.br, o domínio
//     institucional novo) -> site institucional na raiz, com /familia
//     disponível como caminho alternativo pro mesmo módulo.
const isLegacyFamiliaHost =
  typeof window !== 'undefined' &&
  (window.location.hostname.startsWith('familia.') || window.location.hostname === 'localhost');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      {/* Faixa fixa "Vendo como: Secretaria/Pastor" -- so aparece quando um
          ADMIN liga o simulador de perfil em /admin (AdminHome). Fica fora
          do switch de host de proposito, pra valer nos dois. */}
      <ViewAsRoleBanner />
      {/* Esconde/mostra o widget do Barnabe conforme a rota atual, a cada
          navegacao -- ver comentario no proprio componente pro motivo
          (SPA de rota unica, index.html so decide isso uma vez no load). */}
      <AgenteWidgetVisibility />
      {isLegacyFamiliaHost ? (
        <Routes>
          {/* Rota própria, só-admin, pra gestão de papéis -- precisa vir antes
              do coringa "/*" abaixo (que renderiza o Família Mosaico) pra não
              ser engolida por ele. */}
          <Route path="/admin/usuarios" element={<AdminUsuarios />} />
          {/* Gestão do cadastro de membresia -- separado de /admin/usuarios
              (contas de login). Um unico destino (AdminMembrosPortal) decide,
              pelo papel de quem esta logado, entre o cadastro completo
              (ADMIN/SECRETARIA) e a consulta reduzida-LGPD
              (SECRETARIA_CONSULTA) -- antes eram 2 rotas/cards separados
              pro mesmo assunto (ver AdminMembrosPortal.jsx). A rota
              "-consulta" continua de pe por compatibilidade com link antigo:
              cai no mesmo portal, que decide pelo papel de qualquer forma. */}
          <Route path="/admin/membros" element={<AdminMembrosPortal />} />
          <Route path="/admin/membros-consulta" element={<AdminMembrosPortal />} />
          {/* Gestão do cadastro de kids/teens do ministério infantil --
              mesmo padrão de /admin/membros (ver AdminCriancasPortal.jsx). */}
          <Route path="/admin/criancas" element={<AdminCriancasPortal />} />
          <Route path="/admin/criancas-consulta" element={<AdminCriancasPortal />} />
          {/* Acompanhamento de visitantes (quadro de etapas/Kanban, histórico
              de contato) -- antes vivia na aba "Conecta" do Família Mosaico,
              movido pra cá pra ficar junto do resto da gestão administrativa.
              Mesmo padrão de /admin/membros. */}
          <Route path="/admin/visitantes" element={<AdminVisitantes />} />
          {/* Painel de acolhimento (indicadores da comunidade, busca de
              pessoa, histórico de devocionais/conversas) -- mesma origem da
              rota acima, mesmo padrão de /admin/membros. */}
          <Route path="/admin/acolhimento" element={<AdminAcolhimento />} />
          <Route path="/admin/repertorio" element={<AdminRepertorio />} />
          <Route path="/admin/escalas" element={<AdminEscalas />} />
          <Route path="/repertorio" element={<RepertorioMusico />} />
          {/* Aniversariantes do dia -- arte de parabéns e texto pra compartilhar no
              WhatsApp, mesmo padrão de /admin/membros. */}
          <Route path="/admin/aniversariantes" element={<AdminAniversariantes />} />
          <Route path="/admin/agente" element={<AdminAgente />} />
          <Route path="/admin/agente-relatorio" element={<AdminAgentRelatorio />} />
          <Route path="/admin/analytics" element={<AdminAnalytics />} />
          {/* /admin sozinho agora e o painel administrativo (cards pra cada
              area -- usuarios, membros, e o que mais for entrando). */}
          <Route path="/admin" element={<AdminHome />} />
          {/* Formularios publicos de autocadastro (membro, kids/teens e
              visitante) -- compartilhados pela secretaria/acolhimento com
              quem ainda nao tem cadastro. Ficam de pe tambem no host
              familia.* (alem do institucional abaixo) caso o link seja
              aberto por esse dominio por engano. */}
          <Route path="/cadastro/membro" element={<CadastroMembro />} />
          <Route path="/cadastro/crianca" element={<CadastroCrianca />} />
          <Route path="/cadastro/visitante" element={<CadastroVisitante />} />
          <Route path="/*" element={<PrototypeApp />} />
        </Routes>
      ) : (
        <Routes>
          {/* Família Mosaico: módulo autenticado existente, sem nenhuma mudança de
              comportamento interno — ele navega por estado próprio (screen/activeTab),
              não por sub-rotas, então basta montá-lo uma vez sob /familia/*. */}
          {/* /admin/usuarios agora vive também na raiz, igual no domínio
              familia.batistamosaico.com.br (e igual /entrar, /financeiro) --
              antes só existia aninhado em /familia/admin/usuarios. A rota
              aninhada continua de pé por compatibilidade com links antigos. */}
          <Route path="/admin/usuarios" element={<AdminUsuarios />} />
          <Route path="/familia/admin/usuarios" element={<AdminUsuarios />} />
          {/* Gestão do cadastro de membresia -- separado de /admin/usuarios
              (contas de login). Um unico destino (AdminMembrosPortal) decide,
              pelo papel de quem esta logado, entre o cadastro completo
              (ADMIN/SECRETARIA) e a consulta reduzida-LGPD
              (SECRETARIA_CONSULTA) -- antes eram 2 rotas/cards separados
              pro mesmo assunto (ver AdminMembrosPortal.jsx). As rotas
              "-consulta" continuam de pe por compatibilidade com link antigo:
              caem no mesmo portal, que decide pelo papel de qualquer forma. */}
          <Route path="/admin/membros" element={<AdminMembrosPortal />} />
          <Route path="/familia/admin/membros" element={<AdminMembrosPortal />} />
          <Route path="/admin/membros-consulta" element={<AdminMembrosPortal />} />
          <Route path="/familia/admin/membros-consulta" element={<AdminMembrosPortal />} />
          {/* Gestão do cadastro de kids/teens do ministério infantil --
              mesmo padrão de /admin/membros (ver AdminCriancasPortal.jsx). */}
          <Route path="/admin/criancas" element={<AdminCriancasPortal />} />
          <Route path="/familia/admin/criancas" element={<AdminCriancasPortal />} />
          <Route path="/admin/criancas-consulta" element={<AdminCriancasPortal />} />
          <Route path="/familia/admin/criancas-consulta" element={<AdminCriancasPortal />} />
          {/* Acompanhamento de visitantes (quadro de etapas/Kanban, histórico
              de contato) -- antes vivia na aba "Conecta" do Família Mosaico,
              movido pra cá pra ficar junto do resto da gestão administrativa.
              Mesmo padrão de /admin/membros. */}
          <Route path="/admin/visitantes" element={<AdminVisitantes />} />
          <Route path="/familia/admin/visitantes" element={<AdminVisitantes />} />
          {/* Painel de acolhimento (indicadores da comunidade, busca de
              pessoa, histórico de devocionais/conversas) -- mesma origem da
              rota acima, mesmo padrão de /admin/membros. */}
          <Route path="/admin/acolhimento" element={<AdminAcolhimento />} />
          <Route path="/familia/admin/acolhimento" element={<AdminAcolhimento />} />
          <Route path="/admin/repertorio" element={<AdminRepertorio />} />
          <Route path="/familia/admin/repertorio" element={<AdminRepertorio />} />
          <Route path="/admin/escalas" element={<AdminEscalas />} />
          <Route path="/familia/admin/escalas" element={<AdminEscalas />} />
          <Route path="/repertorio" element={<RepertorioMusico />} />
          <Route path="/familia/repertorio" element={<RepertorioMusico />} />
          {/* Aniversariantes do dia -- arte de parabéns e texto pra compartilhar no
              WhatsApp, mesmo padrão de /admin/membros. */}
          <Route path="/admin/aniversariantes" element={<AdminAniversariantes />} />
          <Route path="/admin/agente-relatorio" element={<AdminAgentRelatorio />} />
          <Route path="/familia/admin/agente-relatorio" element={<AdminAgentRelatorio />} />
          <Route path="/admin/analytics" element={<AdminAnalytics />} />
          <Route path="/familia/admin/analytics" element={<AdminAnalytics />} />
          <Route path="/familia/admin/aniversariantes" element={<AdminAniversariantes />} />
          <Route path="/admin/agente" element={<AdminAgente />} />
          <Route path="/familia/admin/agente" element={<AdminAgente />} />
          {/* /admin (e /familia/admin) agora sao o painel administrativo
              (cards pra cada area -- usuarios, membros, e o que mais for
              entrando), em vez de redirecionar direto pra usuarios. */}
          <Route path="/admin" element={<AdminHome />} />
          <Route path="/familia/admin" element={<AdminHome />} />
          <Route path="/familia/*" element={<PrototypeApp />} />
          {/* "Entrar" do site institucional (topbar) aponta pra "/entrar" --
              monta o mesmo modulo, que mostra a tela de login quando nao ha
              sessao (ver activeTab inicial em PrototypeApp.js). */}
          <Route path="/entrar" element={<PrototypeApp />} />

          {/* Site institucional (fase 3) */}
          <Route element={<InstitutionalLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/sobre" element={<Sobre />} />
            <Route path="/ministerios" element={<Ministerios />} />
            <Route path="/pregacoes" element={<Pregacoes />} />
            <Route path="/eventos" element={<Eventos />} />
            <Route path="/contato" element={<Contato />} />
            <Route path="/perguntas-frequentes" element={<Faq />} />
            <Route path="/devocionais" element={<Devocionais />} />
            {/* Formularios publicos de autocadastro -- ver comentario
                equivalente no branch familia.* acima. */}
            <Route path="/cadastro/membro" element={<CadastroMembro />} />
            <Route path="/cadastro/crianca" element={<CadastroCrianca />} />
            <Route path="/cadastro/visitante" element={<CadastroVisitante />} />
          </Route>
        </Routes>
      )}
    </BrowserRouter>
  </React.StrictMode>
);

// Service worker: cache offline (ja existia em public/sw.js, mas nunca tinha
// sido registrado) e canal de notificacao push (usado pelo "Lembrete
// devocional" do Familia Mosaico -- ver src/pushNotifications.js).
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // Registro falhou (ex.: navegador sem suporte real, ambiente de dev
      // sem HTTPS) -- app continua funcionando normalmente sem cache/push.
    });
  });
}
